import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useCIAMHistory } from 'ciam-self-service-shared';
import { mapErrorFromJson } from 'utils/error-map';
import { updateErrorCode } from 'components/Login/actions';

/**
 * User defined hook to handle redirection and setting error code when stage is reset.
 */
const useRedirectOnStageReset = (errorCode, redirectUrl, override) => {
  const history = useCIAMHistory();
  const dispatch = useDispatch();
  const stage = useSelector((state) => state.loginInfo.stage);
  const isForgotPasswordFlow = useSelector((state) => state?.pageInfo?.mfaDetail);
  const updatedErrorCode = !isForgotPasswordFlow && override ? 'G_200' : errorCode;
  const updatedRedirectUrl = !isForgotPasswordFlow && override ? '/' : redirectUrl;

  useEffect(() => {
    if (Object.keys(stage).length === 0) {
      sessionStorage.removeItem('ciam.backButton-otp');
      dispatch(updateErrorCode(mapErrorFromJson(updatedErrorCode)));
      history.push(updatedRedirectUrl, { showError: true });
    }
  }, [stage, dispatch, history, updatedErrorCode, updatedRedirectUrl]);
};

export default useRedirectOnStageReset;
